import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right-circle",
  "use": "arrow-right-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-right-circle\"><path fill-rule=\"evenodd\" d=\"M12 22a10 10 0 1 1 10-10c0 5.523-4.477 10-10 10Zm-6-9h8l-3.5 3.5 1.42 1.42L17.84 12l-5.92-5.92L10.5 7.5 14 11H6v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol